/**
 * Do not edit directly
 * Generated on Monday, August 26, 2024 at GMT-5
 */

exports.Action = {
  "surface": {
    "default": "#333333",
    "subdued": "#F7F7F7",
    "muted": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#757575"
  },
  "text": {
    "default": "#333333",
    "subdued": "#757575",
    "muted": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#757575"
  },
  "border": {
    "default": "#333333",
    "subdued": "#757575",
    "muted": "#DFE0E1",
    "hover": "#000000",
    "enabled": "#333333",
    "disabled": "#DFE0E1"
  },
  "icon": {
    "default": "#333333",
    "subdued": "#757575",
    "muted": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#757575"
  }
}

exports.Core = {
  "background": {
    "primary": "#FFFFFF",
    "secondary": "#FBFBFB",
    "tertiary": "#F7F7F7"
  },
  "surface": {
    "default": "#333333",
    "subdued": "#F7F7F7",
    "muted": "#FBFBFB",
    "inverse": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#F7F7F7",
    "success": "#E9F1E5",
    "warning": "#F6EFDB",
    "critical": "#F2E5E1",
    "info": "#E2E7F0"
  },
  "text": {
    "default": "#333333",
    "subdued": "#757575",
    "inverse": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#757575",
    "critical": "#921100",
    "primary": "#333333",
    "primaryInverse": "#FFFFFF",
    "secondary": "#757575"
  },
  "border": {
    "default": "#333333",
    "subdued": "#757575",
    "muted": "#DFE0E1",
    "inverse": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#DFE0E1",
    "success": "#91A793",
    "warning": "#D1B985",
    "critical": "#D17E70",
    "info": "#7A7885",
    "primary": "#DFE0E1"
  },
  "icon": {
    "default": "#333333",
    "subdued": "#757575",
    "inverse": "#FFFFFF",
    "hover": "#000000",
    "enabled": "#000000",
    "disabled": "#757575",
    "success": "#49694C",
    "warning": "#907C3A",
    "critical": "#921100",
    "info": "#1B2834",
    "favorite": "#921100",
    "primary": "#333333",
    "secondary": "#757575"
  },
  "opacity": {
    "overlay": "rgba(0,0,0,0.03)",
    "mask": "rgba(0,0,0,0.5)"
  }
}

exports.Decorative = {
  "tint": {
    "10": "#FBF8F6",
    "20": "#E9E0DC",
    "30": "#F6EEE4",
    "40": "#ECE3D2",
    "50": "#D9D8CD",
    "60": "#F2F5F5",
    "70": "#E2E7F0",
    "neutral": "#FBF8F6",
    "red": "#E9E0DC",
    "orange": "#F6EEE4",
    "yellow": "#ECE3D2",
    "green": "#D9D8CD",
    "teal": "#F2F5F5",
    "blue": "#E2E7F0"
  },
  "icon": {
    "10": "#B5A998",
    "20": "#BA9B88",
    "30": "#AB7456",
    "40": "#A79764",
    "50": "#91957B",
    "60": "#36676A",
    "70": "#7A7885",
    "neutral": "#B5A998",
    "red": "#BA9B88",
    "orange": "#AB7456",
    "yellow": "#A79764",
    "green": "#91957B",
    "teal": "#36676A",
    "blue": "#7A7885"
  },
  "shade": {
    "10": "#585550",
    "20": "#390D18",
    "30": "#7D3E1E",
    "40": "#595540",
    "50": "#3E4023",
    "60": "#154548",
    "70": "#1B2834",
    "neutral": "#585550",
    "red": "#390D18",
    "orange": "#7D3E1E",
    "yellow": "#595540",
    "green": "#3E4023",
    "teal": "#154548",
    "blue": "#1B2834"
  }
}

exports.TopShop = {
  "shade": {
    "green": "#50583D"
  },
  "icon": {
    "green": "#8B9478"
  },
  "tint": {
    "green": "#DCE3CE"
  }
}
